import run from '../../utilities/run';
import $ from 'jquery';
import _ from "underscore";
import {setElementsFromScope} from "./../../utilities/selectorHelpers";


run("#facilities-lookup", (mainEl)=> {
  const facilityData = mainEl.data("facility-data");
  const facilityFilteredSummaryUrl = mainEl.data("facility-filtered-summary-url");
  const viewOrderRenderUrl=mainEl.data("view-order-render-url");
  const viewInboundRenderUrl=mainEl.data("view-inbound-render-url");
  const els = {};
  const elementsMap = {
    addFacilitySelect : '#facility-select',
    ordersShippedPill : '#orders-shipped-pill',
    shipmentsReceivedPill : '#shipments-received-pill'
  }

  function init() {
    setElements();
    bindElements();
    renderFacilityList();
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, mainEl);
  }
    
  function bindElements(){ 
    els.addFacilitySelect.on('change', loadFacilityFilteredData); 
  }
    
  function renderFacilityList(){
    $(facilityData).each(function(){
      var option=$('<option />');
      option.attr('value', this.facId).text(this.facName);
      els.addFacilitySelect.append(option);
    });
  }
  
  function loadFacilityFilteredData() {
    let facId = els.addFacilitySelect.val();
    let newviewUrl=`${facilityFilteredSummaryUrl}&facId=${facId}`;
    $.ajax({
      url: newviewUrl,
      type: 'POST',
      dataType: "JSON",
      data: { 
        facId: facId
      },
      success: function(response){

        $('#orders-shipped-pill').attr('href',viewOrderRenderUrl+"&filterSummary=Shipped&filterFlag=fourteendays&facId="+facId);
        $('#shipments-received-pill').attr('href',viewInboundRenderUrl+"&filterSummary=Complete&filterFlag=fourteendays&facId="+facId);
        let orderShippedIsOver = response.orderShippedPercentage >= 0;

        let orderShippedPercentageText = orderShippedIsOver 
              ? response.orderShippedPercentage + '% over previous period'
              : Math.abs(response.orderShippedPercentage) + '% under previous period';

        let shipmentReceivedIsOver = response.shipmentReceivedPercentage >= 0;

        let shipmentReceivedPercentageText = shipmentReceivedIsOver
              ? response.shipmentReceivedPercentage + '% over previous period' 
              : Math.abs(response.shipmentReceivedPercentage) + '% under previous period';

        $('#orders-shipped-pill').html(response.orderShippedNewCount);

        if (orderShippedIsOver) {
          $('#orders-shipped-increase-true').css('display', 'block');
          $('#orders-shipped-increase-true-text').html(orderShippedPercentageText);
          $('#orders-shipped-increase-false').css('display', 'none');
        } else {
          $('#orders-shipped-increase-false').css('display', 'block');
          $('#orders-shipped-increase-false-text').html(orderShippedPercentageText);
          $('#orders-shipped-increase-true').css('display', 'none');
        }

        $('#shipments-received-pill').html(response.shipmentReceivedNewCount);

        if (shipmentReceivedIsOver) {
          $('#shipment-received-increase-true').css('display', 'block');
          $('#shipment-received-increase-true-text').html(shipmentReceivedPercentageText);
          $('#shipment-received-increase-false').css('display', 'none');
        } else {
          $('#shipment-received-increase-false').css('display', 'block');
          $('#shipment-received-increase-false-text').html(shipmentReceivedPercentageText);
          $('#shipment-received-increase-true').css('display', 'none');
        }
      },
      error: function(e, ajaxOptions, thrownError) {
        console.log(e);        
      }
    });
  }

  init();

});



// WEBPACK FOOTER //
// ./src/pages/dashboard/summary-view.js